<script>
import 'select2';
import formInput from "@/mixins/shared/formInput";

// https://select2.org/programmatic-control/events
const select2Events = [
	'select2:closing',
	'select2:close',
	'select2:opening',
	'select2:open',
	'select2:selecting',
	'select2:select',
	'select2:unselecting',
	'select2:unselect',
	'select2:clearing',
	'select2:clear',
];

export default {
	emits: [
		...select2Events
	],
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'ajaxUrl': {
			type: String,
			required: false
		},
		'options': {
			type: Array,
			default: []
		},
		'placeholder': {
			type: String,
			required: false,
		},
		'currentValueLabel': {
			type: String,
			required: false,
		},
		'tags': {
			type: Boolean,
			default: false,
		},
		'multiple': {
			type: Boolean,
			default: false,
		},
		'alterSettings': {
			type: Function,
			required: false,
			default: null,
		}
	},
	methods: {
		async initialiseSelect2() {
			if ($(this.$refs.select).data('select2')) {
				if ($(this.$refs.select).data('select2').isOpen()) {
					$(this.$refs.select).select2('close');
				}
				$(this.$refs.select).select2('destroy');
				if (this.modelValue == 0 || this.modelValue == null) {
					this.key = Math.random();
				}
			} else {
				this.key = Math.random();
			}

			await this.$nextTick();

			let $select = $(this.$refs.select);
			let settings = await this.getSelectSettings($select);

			$select.select2(settings);
			this.addChangeEventListener();
		},

		isSelected(option) {
			if (Array.isArray(this.modelValue)) {
				return this.modelValue.includes(option.id || option.value) || this.modelValue.includes(`${option.id ?? option.value}`);
			}
			return (option.id ?? option.value) == this.modelValue
		},

		setModelValue(event) {
			let value = $(event.currentTarget).select2('val');
			let result = null;

			if (this.multiple) {
				result = [];
				for (let index in value) {
					result[index] = this.toNumericIfNeeded(value[index]);
				}
			} else {
				result = this.toNumericIfNeeded(value);
			}

			this.changeModelValueTo(result)
		},

		toNumericIfNeeded(value) {
			if (value == null)
				return value;
			if (!isNaN(value)) {
				return value * 1;
			}
			return value;
		},

		addChangeEventListener() {
			$(this.$refs.select).off('.app.select2');
			$(this.$refs.select).on('change.app.select2', this.setModelValue.bind(this));

			for (let index in select2Events) {
				let eventName = select2Events[index];
				$(this.$refs.select).on(eventName + '.app.select2', event => this.$emit(eventName, event));
			}
		},

		async getSelectSettings($select) {
			let settings = {
				theme: 'bootstrap-5',
			}

			if (this.ajaxUrl) {
				settings['ajax'] = {
					url: this.ajaxUrl,
					dataType: 'json',
					delay: 200
				}
			}

			if (this.tags) {
				settings['tags'] = true;
			}

			if (this.placeholder) {
				settings['placeholder'] = this.placeholder;
			}

			if (this.placeholder && !this.multiple) {
				settings['allowClear'] = true;
			}

			let $modal = $select.closest('.modal-body');
			if ($modal.length > 0) {
				settings['dropdownParent'] = $modal[0];
			}

			if (this.alterSettings) {
				await this.alterSettings(settings);
			}

			return settings;
		}
	},

	mounted() {
		this.initialiseSelect2();
		this.$watch('modelValue', event => this.initialiseSelect2());
		this.$watch('placeholder', event => this.initialiseSelect2());
	},

	data() {
		return {
			key: Math.random()
		}
	}
}
</script>

<template>
	<div :key="key" :class="{[groupClasses]: groupClasses, 'select-has-errors': hasError}">
		<div :class="{'input-group' : true, [groupClasses] : true}">
			<span class="input-group-text" v-if="$slots.addonbefore">
				<slot name="addonbefore" />
			</span>
			<div :class="{'w-100' : !($slots.addonbefore || $slots.addonafter), 'flex-grow-1':$slots.addonbefore || $slots.addonafter,'no-rounded-start' : $slots.addonbefore, 'no-rounded-end' : $slots.addonafter}">
				<select
					ref="select"
					:name="name"
					:id="renderedId"
					v-bind="$attrs"
					class="form-control"
					:multiple="multiple"
				>
					<option v-if="options.length < 1 && currentValueLabel && modelValue" :value="modelValue" selected>{{ currentValueLabel }}</option>
					<slot/>
					<option v-for="option in options" :selected="isSelected(option)" :value="option.id ?? option.value">{{ option.text ?? option.label }}</option>
				</select>
			</div>
			<span class="input-group-text" v-if="$slots.addonafter">
				<slot name="addonafter" />
			</span>
		</div>
		<div v-if="$slots.descriptionbottom" class="input-description mt-2">
			<slot name="descriptionbottom" />
		</div>
		<label v-if="hasError" class="text-danger mt-2 small">{{ this.form.errors[this.name] }}</label>
	</div>
</template>